import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouteDetailsComponent } from './route-details.component';
import { SharedModule } from 'app/shared/shared.module';
import { AssignEmployeeModule } from '../assign-employee/assign-employee.module';
import { RouteFormModule } from '../route-form/route-form.module';
import { JobReorderModule } from '../job-reorder/job-reorder.module';
import { DataPickerModule } from '../data-picker/data-picker.module';
import { AssignRouteModule } from '../assign-route/assign-route.component.module';
import { PreviewDataModule } from '../preview-data/preview-data.module';
import { RemoveJobModule } from '../remove-job/remove-job.module';
import { CreateRouteFormModule } from '../create-route-form/create-route-form.module';

@NgModule({
    declarations: [
        RouteDetailsComponent
    ],
    exports: [
        RouteDetailsComponent
    ],
    imports: [
        SharedModule,
        AssignEmployeeModule,
        CommonModule,
        RouteFormModule,
        JobReorderModule,
        DataPickerModule,
        AssignRouteModule,
        PreviewDataModule,
        RemoveJobModule,
        CreateRouteFormModule
    ]
})
export class RouteDetailsModule { }
